import React from 'react';
import { ChevronDown, Wifi, WifiOff } from 'lucide-react';
import { getModelDisplay } from '../chat/ChatMessage';

const ChatHeader = ({ modelId, connected, credits, creditDelta }) => {
  const modelInfo = getModelDisplay(modelId || 'auto');

  return (
    <div className="flex items-center justify-between px-5 py-3 border-b border-border bg-background">
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2 px-3 py-1.5 bg-muted rounded-lg border border-border cursor-pointer hover:bg-accent transition-colors">
          <div className={`w-5 h-5 rounded ${modelInfo.color} flex items-center justify-center text-[10px] font-bold`}>{modelInfo.icon}</div>
          <span className="text-sm text-foreground font-medium">{modelInfo.name}</span>
          <ChevronDown className="w-3.5 h-3.5 text-muted-foreground" />
        </div>
        <div className={`flex items-center gap-1 text-xs ${connected ? 'text-emerald-600' : 'text-muted-foreground'}`} data-testid="ws-status">
          {connected ? <Wifi className="w-3 h-3" /> : <WifiOff className="w-3 h-3" />}
          {connected ? 'Live' : 'REST'}
        </div>
      </div>
      <div className="flex items-center gap-1.5 text-sm relative" data-testid="chat-credit-indicator">
        <span className="text-muted-foreground">Credits:</span>
        <span className="text-foreground font-semibold">{credits ?? '—'}</span>
        {creditDelta !== null && <span className="absolute -top-3 -right-2 text-xs font-bold text-red-500 animate-bounce" data-testid="credit-delta">{creditDelta}</span>}
      </div>
    </div>
  );
};

export default ChatHeader;
